import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { Filters } from "./shared";

/**
 * Query keys for tag entity.
 */
export const tagKeys = createQueryKeys("tag", {
	all: null,
	records: (filters: Filters = {}) => ({
		queryKey: ["records", filters],
	}),
	record: (id: string) => ({
		queryKey: ["record", id],
	}),
});
